<template>
<div class="chapter">
<div class="inner_page">
<p class="toch">CONTENTS</p>
<p class="toc1"><a href="#/dedication">Dedication</a></p>
<p class="toc1"><a href="#/Election_night">Election Night</a></p>
<p class="toc1"><a href="#/ch_01">Day One</a></p>
<p class="toc1"><span href="#/ch_02" title="Link target outside of Sample">Day Two</span></p>
<p class="toc1"><span href="#/ch_03" title="Link target outside of Sample">Day Three</span></p>
<p class="toc1"><span href="#/ch_04" title="Link target outside of Sample">Day Four</span></p>
<p class="toc1"><span href="#/ch_05" title="Link target outside of Sample">Day Five</span></p>
<p class="toc1"><span href="#/ch_06" title="Link target outside of Sample">Day Six</span></p>
<p class="toc1"><span href="#/ch_07" title="Link target outside of Sample">Day Seven</span></p>
<p class="toc1"><span href="#/ch_08" title="Link target outside of Sample">Day Eight</span></p>
<p class="toc1"><span href="#/ch_09" title="Link target outside of Sample">Day Nine</span></p>
<p class="toc1"><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc1"><span href="#/about_the_author" title="Link target outside of Sample">About the Author</span></p>
<p class="toc1"><span href="#/copyright" title="Link target outside of Sample">Copyright Page</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?498af236